// extracted by mini-css-extract-plugin
module.exports = {"loader":"LayoutWrapperSideNav_loader__gHZXN","root":"LayoutWrapperSideNav_root__4JRou","tabs":"LayoutWrapperSideNav_tabs__3zzuI","tab":"LayoutWrapperSideNav_tab__4r23v"};